import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import _ from 'lodash';
dayjs.extend(utc);
export var utcFormatFromString = function (datetime) {
    if (datetime === 'now.toUTCSTring()') {
        return dayjs.utc().format('YYYY-MM-DD HH:mm:ss');
    }
    return datetime ? dayjs.utc(datetime).format('YYYY-MM-DD HH:mm:ss') : '-';
};
export var shortFormatFromString = function (datetime) {
    if (datetime === 'now.toUTCSTring()') {
        return dayjs.utc().format('YYYY-MM-DD');
    }
    return datetime ? dayjs.utc(datetime).format('YYYY-MM-DD') : '-';
};
export var durationFormat = function (formatedObj) {
    var formatedValue = _.keys(formatedObj).map(function (key) {
        if (formatedObj[key] !== 0) {
            return formatedObj[key] + key;
        }
        return "";
    }).join(" ");
    return formatedValue;
};
export var utcFormatFromDate = function (datetime) { return dayjs(datetime).utc().format('YYYY-MM-DD HH:mm:ss'); };
export var datePickerFormatUTC = function (dateInt, addOffset) {
    if (addOffset === void 0) { addOffset = false; }
    var date = (!dateInt || dateInt.length < 1) ? new Date : new Date(dateInt);
    if (typeof dateInt === "string") {
        return date;
    }
    else {
        var offset = addOffset ? date.getTimezoneOffset() : -(date.getTimezoneOffset());
        var offsetDate = new Date();
        offsetDate.setTime(date.getTime() - offset * 60000);
        return offsetDate;
    }
};
